const OpenAIConstants = {
    MODEL: "gpt-4o-mini", // gpt-4o-mini / gpt-4o
    TEMPERATURE: 0.7,
    MAX_TOKENS: 200,
    TOP_P: 1,
    FREQUENCY_PENALTY: 0,
    PRESENCE_PENALTY: 0
};

export default OpenAIConstants;